module.exports = __webpack_public_path__ + "img/img1.4c65f05f.png";